import { createSlice } from "@reduxjs/toolkit";
import { SliceAction } from "store/store";

const queryParamsLS = JSON.parse(window.localStorage.getItem("adminDashboardPage") || "{}");
const queryParamsURL = Object.fromEntries(new URLSearchParams(window.location.search));

const isActivePage = window.location.pathname.includes("statistics") && (queryParamsURL?.tab === "dashboard")

const initialState: {
    activeStartDate: string,
    activeEndDate: string,
} = Object.assign(
    (isActivePage && Object.keys(queryParamsURL).some(item => ["startDate", "endDate"].includes(item)))
        ? {
            activeStartDate: queryParamsURL?.startDate || "",
            activeEndDate: queryParamsURL?.endDate || "",
        }
        : {
            activeStartDate: queryParamsLS?.startDate || "",
            activeEndDate: queryParamsLS?.endDate || "",
        }
);

window.localStorage.setItem("adminDashboardPage", JSON.stringify({
    startDate: initialState.activeStartDate,
    endDate: initialState.activeEndDate,
}))

const dashboardSlice = createSlice({
    initialState,
    name: "dashboardAdminPage",
    reducers: {
        setActiveStartDate(state, action: SliceAction<(typeof initialState)["activeStartDate"]>) {
            window.localStorage.setItem("adminDashboardPage", JSON.stringify({
                startDate: action.payload,
                endDate: state.activeEndDate,
            }))
            state.activeStartDate = action.payload;
        },
        setActiveEndDate(state, action: SliceAction<(typeof initialState)["activeEndDate"]>) {
            window.localStorage.setItem("adminDashboardPage", JSON.stringify({
                startDate: state.activeStartDate,
                endDate: action.payload,
            }))
            state.activeEndDate = action.payload;
        },
    },
});

const { reducer, actions } = dashboardSlice;

export default reducer;

export const {
    setActiveEndDate,
    setActiveStartDate,
} = actions;
